import { Styles, generateClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const appHeaderTitleClasses = generateClasses('AppHeaderTitle', [
  'root',
  'title',
  'svgContainer',
  'titleSvg',
] as const);

export const appHeaderTitleRootClasses = generateClasses(appHeaderTitleClasses.root, ['simple'] as const, true);

const styles: Styles = ({ theme, theme: { spacing } }) => {
  const {
    appHeader: {
      text: { defaultTextColor, appTitleColor },
      customerLogo: { hideCustomerLogo },
    },
  } = getAppFrameTheme(theme);

  return {
    [`&.${appHeaderTitleClasses.root}`]: {
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: spacing(hideCustomerLogo ? 1.25 : 0),
      alignItems: 'center',
      userSelect: 'none',

      [`&.${appHeaderTitleRootClasses.simple}`]: {
        width: '100%',
        height: 'auto',
      },
    },

    [`.${appHeaderTitleClasses.svgContainer}`]: {
      display: 'flex',
      width: 'auto',
      maxWidth: 100,
      height: 12,
    },

    [`.${appHeaderTitleClasses.titleSvg}`]: {
      objectFit: 'contain',
      objectPosition: 'left',
    },

    [`.${appHeaderTitleClasses.title}`]: {
      color: appTitleColor ?? defaultTextColor,
      fontSize: 18,
      fontFamily: 'LufthansaTextWeb',
      fontWeight: 700,
      letterSpacing: '-0.045rem',
    },
  };
};
export default styles;
